import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getTimeIntervals } from "../ApiService/ApiService";

export const fetchTimeIntervalsAsync = createAsyncThunk(
  "timeIntervals/fetchTimeIntervals",
  async () => {
    const response = await getTimeIntervals();
    return response.data;
  }
);

const initialState = {
  timeIntervals: [],
  loading: false,
  error: null,
};

export const timeIntervalsSlices = createSlice({
  name: "timeIntervals",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTimeIntervalsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTimeIntervalsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.timeIntervals = action.payload;
      })
      .addCase(fetchTimeIntervalsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const selectAllTimeIntervals = (state) =>
  state.timeIntervals.timeIntervals;
export const selectTimeIntervalsLoading = (state) =>
  state.timeIntervals.loading;
export const selectTimeIntervalsError = (state) => state.timeIntervals.error;

export default timeIntervalsSlices.reducer;
